// extracted by mini-css-extract-plugin
export default {"required-indicator-content":"required-indicator-content-sLDg6JB"};